import { assertValidVersion } from "@tsparticles/engine";
import { ParallaxMover } from "./ParallaxMover.js";
export async function loadParallaxMover(engine, refresh = true) {
    assertValidVersion(engine, "3.7.1");
    await engine.addMover("parallax", () => {
        return Promise.resolve(new ParallaxMover());
    }, refresh);
}
